<template>
  <div class="microphoneSetting2 flexcenter">
    <transition>
      <div class="microphoneSettingDialog2 flexcenter">
        <!-- 閉じる -->
        <div class="modal-close" v-on:click="close"></div>
        <div class="microphoneSettingDialog2Inner">
        <!-- タイトル -->
        <h3>マイク設定</h3>

        <div class="modal-inner">
          <!-- 初期 -->
          <div class="inittext" v-if="viewState === 'init'">
            <div v-if="isFlash">
              <p><span class="num">①</span>以下の手順に従って、本サイトのマイク使用が許可されていることを確認します。</p>
              <p><span class="anchor"><a class="mic-anchor" href="http://www.sourcenext.com/support/qa/?faq=RS-08885" target="_blank">http://www.sourcenext.com/support/qa/?faq=RS-08885</a></span></p>
              <p><span class="num">②</span>図のとおりにヘッドセットを装着します。</p>
              <p><span class="num">③</span>[続行]をクリックして開始します。</p>
              <p><span class="num">④</span>音が聞こえたら、いつも通りの声で「1、2、3、4、5」と言ってください。</p>
            </div>
            <div v-else>
              <p><span class="num">①</span>図のとおりにヘッドセットを装着します。</p>
              <p><span class="num">②</span>[続行]をクリックして開始します。</p>
              <p><span class="num">③</span>音が聞こえたら、いつも通りの声で「1、2、3、4、5」と言ってください。</p>
            </div>
          </div>
          <!-- 設定中 -->
          <div class="setting" v-else-if="viewState === 'setting'">
            <p>「1、2、3、4、5」と話します。</p>
            <!-- 音声ボリュームをインジケータに反映する。 -->
            <div class="indicator flexbetween">
              <div v-for="n in 11">
                <span class="mic-icon" v-if="11 == n"><img src="../../static/images/icon/setting/mic_icon.png"/></span><span class="on" v-else-if="volumeIndicator >= n"></span><span class="off" v-else></span>
              </div>
            </div>
          </div>
          <!-- 設定成功 -->
          <div class="success" v-else-if="viewState === 'success'">
            <p>マイクが正しく設定されました。</p>
            <p>設定を保存するには、[続行]をクリックします。</p>
          </div>
          <!-- 設定失敗 -->
          <div class="failed" v-else-if="viewState === 'fail'">
            <p>マイクを正しく設定できていません。</p>
          </div>
          <!-- 共通 -->
          <div class="common">
            <div class="num align-center lbold font28"><span>1</span><span>.</span><span>2</span><span>.</span><span>3</span><span>.</span><span>4</span><span>.</span><span>5</span></div>
            <div class="headphone align-center font12"><img src="../../static/images/icon/setting/microphone.png"/></div>
            <p v-if="platform.name == 'Chrome'" class="current-mic align-center font12">現在選択されているマイク: {{ microphone.name }}</p>
          </div>
        </div>
        <!-- ボタン -->
        <div class="buttons flexcenter">
          <button class="cancel" type="button" :disabled="locked" @click="doCancel">{{ buttonCancel }}</button>
          <button class="continue" type="button" :disabled="locked" @click="doContinue">{{ buttonContinue }}</button>
        </div>
      </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

var platform = require('platform')

const VIEW_STATE_INIT = 'init'
const VIEW_STATE_SETTING = 'setting'
const VIEW_STATE_SUCCESS = 'success'
const VIEW_STATE_FAIL = 'fail'

const BUTTON_TEXT_CANCEL = 'キャンセル'
const BUTTON_TEXT_REDO = '設定をやり直す'
const BUTTON_TEXT_CONTINUE = '続行'

export default {
  name: 'microphoneSetting',
  mixins: [
    common,
  ],
  props: {
    microphone: Object,
  },
  data: function() {
    return {
      viewState: VIEW_STATE_INIT,
      buttonCancel: BUTTON_TEXT_CANCEL,
      buttonContinue: BUTTON_TEXT_CONTINUE,
      locked: false,
      volumeIndicator: 0,
      currentMicrophone: null,
      isFlash: false,
    }
  },
  computed: {
    platform: () => platform,
  },
  methods: {
    /**
     * 続行処理
     */
    doContinue: async function() {
      this.log("MicrophoneSetting start doContinue")
      switch (this.viewState) {
        case VIEW_STATE_INIT:
          this.setting()
          break
        case VIEW_STATE_FAIL:
          // マイク設定処理実行可否判定
          if (await this.canCalibration()) {
            this.setting()
          } else {
            // マイク選択画面の一覧更新
            var microphoneSelect = this.$parent.$children.find(function(child){ return child.$options.name == "microphoneSelect" })
            if (microphoneSelect) {
              microphoneSelect.updateList()
            }
            this.close()
          }
          break
        case VIEW_STATE_SUCCESS:
          this.close()
          break
      }
    },
    /**
     * キャンセル処理
     */
    doCancel: function() {
      this.log("MicrophoneSetting start doCancel")

      switch (this.viewState) {
        case VIEW_STATE_INIT:
        case VIEW_STATE_FAIL:
          this.close()
          break
        case VIEW_STATE_SUCCESS:
          this.setting()
          break
      }
    },
    /**
     * マイク設定処理の実行可否を返す
     *
     * @return {Boolean} true:実行可, false:実行不可
     */
    canCalibration: async function () {
      switch (platform.name) {
        case "Chrome":
          return !await this.needsMicrophoneSetting(this.microphone)
        default:
          return true
      }
    },
    /**
     * マイク設定処理
     */
    setting: async function () {
      var self = this

      if (!await self.canCalibration()) {
        self.viewState = VIEW_STATE_FAIL
        self.buttonCancel = BUTTON_TEXT_CANCEL
        self.buttonContinue = BUTTON_TEXT_REDO
        return
      }

      self.locked = true
      self.volumeIndicator = 0
      self.viewState = VIEW_STATE_SETTING

      var isInput = false
      var callbacks = {
        update: function () {
          isInput = true
          self.volumeIndicator = sonic_wrapper.getCalibrateEnergy()
        },
        end: function () {
          // 中断された場合は画面を閉じる
          if (sonic_wrapper.isStopReasonManual()) {
            self.$emit('close')
            return
          }

          var succeeded = isInput && (sonic_wrapper.isCalibrationResultOk())
          // Chrome以外で失敗時はヘルプ画面を表示
          if (platform.name != "Chrome" && !succeeded) {
            self.$emit('showMicrophoneHelp')
          }
          self.viewState = succeeded ? VIEW_STATE_SUCCESS : VIEW_STATE_FAIL
          self.buttonCancel = succeeded ? BUTTON_TEXT_REDO : BUTTON_TEXT_CANCEL
          self.buttonContinue = succeeded ? BUTTON_TEXT_CONTINUE : BUTTON_TEXT_REDO
          self.locked = false
        }
      }
      sonic_wrapper.calibration(callbacks)
    },
    /**
     * 本画面を閉じる
     */
    close: function () {
      if (platform.name == "Chrome") {
        switch (this.viewState) {
          case VIEW_STATE_INIT:
          case VIEW_STATE_FAIL:
            // 使用マイクを元に戻す
            sonic_wrapper.setUseMicrophone(this.currentMicrophone)
            break
          case VIEW_STATE_SUCCESS:
            // マイク選択画面を閉じる
            var microphoneSelect = this.$parent.$children.find(function(child){ return child.$options.name == "microphoneSelect" })
            if (microphoneSelect) {
              microphoneSelect.close()
            }
            break
        }
      }
      // SpeechSession実行中の場合
      if (sonic_wrapper.isSessionRunning()) {
        // セッション中断
        sonic_wrapper.interruptSession()
      } else {
        this.$emit('close')
      }
    },
  },
  created: function() {
    this.log("MicrophoneSetting start created")

    // Flash版で動作中か否か
    this.isFlash = this.isForceFlash()

    // Chromeの場合は使用マイクを設定する
    if (platform.name == "Chrome") {
      // 現在設定されているマイク情報を保持
      this.currentMicrophone = sonic_wrapper.getMicrophone()
      // 使用マイクを仮設定
      sonic_wrapper.setUseMicrophone(this.microphone)
    }
  },
  mounted: function() {
    this.log("MicrophoneSetting start mounted")
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// MicrophoneSetting.vue?735c2815